import { Navigate, useLocation } from 'react-router-dom';

import useSentinelTeam from 'hooks/useSentinelTeam';
import { useCurrentUserContext } from 'utils/User';
import ROUTE_NAMES from 'setup/Routing/routeNames';

type Props = {
  children: React.ReactNode;
};

// this route is used to block access to /reports when Insite Reports is enabled
// eventually this will be removed when Insite Reports is fully rolled out
export default function ReportsRoute({ children }: Props) {
  const { isSuperUser } = useCurrentUserContext();
  const { oemSegment } = useSentinelTeam();
  const location = useLocation();

  const insiteReportsEnabled = oemSegment?.settings?.showInsiteReports ?? false;

  if (insiteReportsEnabled) {
    const path = isSuperUser ? '/' : ROUTE_NAMES.access_denied;
    return <Navigate to={path} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
